import { CookieManager } from "../services/CookieManager/CookieManager";
import { DEVICE_COOKIE, MARKETING_COOKIE } from "@nf/constants";

const expireInNextWeek: Date = new Date(
  new Date().setDate(new Date().getDate() + 7)
);

export const CookieHelper = {
  getDevice: () => {
    try {
      const device = CookieManager.getCookie(DEVICE_COOKIE) as string;
      const parsedDevice = JSON.parse(device);
      return Promise.resolve(parsedDevice);
    } catch {
      return Promise.resolve(undefined);
    }
  },

  setDevice: (value: string) => {
    const expiresInYear: Date = new Date(
      new Date().setFullYear(new Date().getFullYear() + 1)
    );
    CookieManager.add(DEVICE_COOKIE, value, expiresInYear);
    return Promise.resolve();
  },

  setMarketing: (value?: boolean) => {
    CookieManager.add(MARKETING_COOKIE, !!value, expireInNextWeek);
    return Promise.resolve();
  },
};
